import { UploadOutlined } from "@ant-design/icons";
import { Upload as AntdUpload, Button, Form } from "antd";
import { Upload } from "lucide-react";
import { FC } from "react";

type Props = {};

export const TabDocuments: FC<Props> = () => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-6">Documents</h2>

      <div className="space-y-6">
        {/* Upload Area */}
        <div className="p-6 border-2 border-dashed rounded-lg text-center">
          <Form.Item
            name="files"
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) {
                return e;
              }
              return e && e.fileList;
            }}
            rules={[{ required: false }]} // Can add required: true if needed
          >
            <AntdUpload
              name="file"
              multiple
              beforeUpload={() => false} // Prevent auto upload, handle manually if needed
              accept=".pdf,.doc,.docx,.jpg,.png"
              maxCount={5} // File limit, can be changed
            >
              <div>
                <Upload size={32} className="mx-auto text-gray-400 mb-2" />
                <p className="text-gray-600 mb-2">
                  Drag and drop files here, or click to select files
                </p>
                <p className="text-xs text-gray-500 mb-4">
                  Accepted file types: PDF, DOC, DOCX, JPG, PNG (Max 10MB)
                </p>
                <Button
                  icon={<UploadOutlined />}
                  className="bg-blue-600 text-white hover:bg-blue-700 border-none"
                >
                  Select Files
                </Button>
              </div>
            </AntdUpload>
          </Form.Item>
        </div>

        {/* Document Types */}
        <div className="p-4 border rounded-lg bg-gray-50">
          <h3 className="font-medium mb-4">Required Documents</h3>
          <ul className="space-y-2 text-sm text-gray-600">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Contract or Service Agreement</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Tax Exemption Certificate (if applicable)</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Insurance Certificate</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Credit Application (for Net Terms)</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
